import { useTranslations } from "next-intl"

export function useOfficeAddress() {
    const t = useTranslations("useOfficeAddress")

    return {
        address: t("address"),
        postalCode: t("postalCode"),
        fullAddress: `${t("address")}, ${t("postalCode")}`,
    }
}

useOfficeAddress.messages = ["useOfficeAddress"] as const
